import React from "react";
import { Link } from "react-router-dom";

function Error404() {
  return (
    <section className="error-page">
      <article className="content">
        <h2 class="title">Page not available</h2>
        <p>This page is not available.</p>
        <p>Please go to the navigation menu to select another option.</p>
        <p>
          Alternatively, go back to{" "}
          <Link exact to="/" className="link-inline">
            home
          </Link>
        </p>
      </article>
    </section>
  );
}

export default Error404;
